import Module from './Module';

const module = new Module('admins', '/api/v1/admins');

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/admins.js